/** The terms sign-off step of a sign-in: read the live agreement, then accept it. */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { AuthEndpoints } from 'src/@shared/endpoints/endpoints';
import { environment } from 'src/environments/environment';
import {
  AcceptTermsRequest,
  ApiEnvelope,
  LoginSuccessResult,
  PendingTerms,
  PolicyType,
  PublicPolicy,
} from './auth.models';

/**
 * Every call here runs without a bearer token: the caller has passed identity, 2FA and the device
 * check, but holds only the one-time terms token until they accept.
 */
@Injectable({
  providedIn: 'root',
})
export class TermsGateApiService {
  constructor(private _cS: CommonService, private http: HttpClient) {}

  /** Plain HttpClient: CommonService.API_GET refuses to call the API without a bearer token. */
  pending(token: string): Observable<ApiEnvelope<PendingTerms>> {
    return this.http.get<ApiEnvelope<PendingTerms>>(
      `${environment.apiURL}${AuthEndpoints.TermsPending}?token=${encodeURIComponent(token)}`
    );
  }

  /** On success the response is an ordinary completed sign-in, stored like any other. */
  accept(body: AcceptTermsRequest): Observable<ApiEnvelope<LoginSuccessResult>> {
    return this._cS.API_POST(AuthEndpoints.TermsAccept, body, false);
  }

  /** Privacy and Cookie policies for the footer links. Published documents, never agreements. */
  policy(termsType: PolicyType): Observable<ApiEnvelope<PublicPolicy>> {
    return this.http.get<ApiEnvelope<PublicPolicy>>(
      `${environment.apiURL}${AuthEndpoints.TermsPolicy}/${termsType}`
    );
  }
}
